import { render, staticRenderFns } from "./OkDialog.vue?vue&type=template&id=432a7e74"
import script from "./OkDialog.vue?vue&type=script&lang=ts"
export * from "./OkDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports